import React from 'react';
import { Alert, Box } from '@nextiva/next-ui-components';
import * as RoleTypes from 'types/Role';
import * as UserTypes from 'types/User';
import * as LaunchpadConstants from 'constants/launchpad';
import {
  validatePermission,
  userIsSuperAdmin,
  voiceAdminDisabledDueToBwPatchingChecker,
} from 'utils/launchpad';

const TEST_ID = `${LaunchpadConstants.TEST_ID}-Alert`;

interface LaunchpadAlertProps {
  featureState: Record<PropertyKey, any>;
  isQueryError: boolean;
  isVoiceAccount: boolean;
  userPermissions: RoleTypes.Permissions[];
  roles: RoleTypes.Role[];
  user: UserTypes.User;
}

export const LaunchpadAlert = ({
  featureState,
  isQueryError,
  isVoiceAccount,
  userPermissions,
  roles,
  user,
}: LaunchpadAlertProps) => {
  const { isClusterIdInBWPatching } = featureState;
  const userPrimaryIdentifier = Boolean(
    user.profileDTO?.nextOSIdent?.primaryIdentifier,
  );

  const roleIsSuperAdmin = userIsSuperAdmin(roles);

  const isAdminAndVoiceUser = validatePermission(
    LaunchpadConstants.PERMISSION_TYPES.communications.resourceId,
    userPermissions,
    LaunchpadConstants.PERMISSION_TYPES.communications.voice,
    roleIsSuperAdmin,
  );

  const isVoiceAdminDisabledDueToBwPatching = voiceAdminDisabledDueToBwPatchingChecker(
    {
      isAdminAndVoiceUser,
      isClusterIdInBWPatching,
      isVoiceAccount,
      userPrimaryIdentifier,
    },
  );

  if (isQueryError) {
    return (
      <Box
        sx={{
          mb: '32px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Alert severity="warning" data-testid={`${TEST_ID}-QueryError`}>
          {LaunchpadConstants.QUERY_ERROR_MESSAGE}
        </Alert>
      </Box>
    );
  }

  if (isVoiceAdminDisabledDueToBwPatching) {
    return (
      <Box
        sx={{
          mb: '32px',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <Alert severity="warning" data-testid={`${TEST_ID}-BwPatching`}>
          {LaunchpadConstants.VOICE_ADMIN_DISABLE_DUETO_BWPATCHING}
        </Alert>
      </Box>
    );
  }
  return null;
};
